/* eslint-disable no-empty-pattern */
import apiClientV1 from "@/config/apiv1";

const RESOURCE = "/plans";
const ADMIN = "/admin/plans";

const actions = {
  getPublicPlans({ commit }) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .get(RESOURCE)
        .then((res) => {
          commit("SET_PUBLIC_PLANS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => reject(err));
    });
  },

  getAdminPlans({ commit }) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .get(ADMIN)
        .then((res) => {
          commit("SET_ADMIN_PLANS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => reject(err));
    });
  },

  createPlan({}, payload) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .post(ADMIN, payload)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },

  updatePlan({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .put(`${ADMIN}/${id}`, payload)
        .then((res) => {
          commit("UPDATE_PLAN", res.data.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },

  deletePlan({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .delete(`${ADMIN}/${id}`)
        .then((res) => {
          commit("REMOVE_PLAN", id);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  },

  getPlanPrices({}, planId) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .get(`${ADMIN}/${planId}/prices`)
        .then((res) => resolve(Array.isArray(res.data) ? res.data : res.data.data))
        .catch((err) => reject(err));
    });
  },

  createPlanPrice({}, { planId, payload }) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .post(`${ADMIN}/${planId}/prices`, payload)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },

  updatePlanPrice({}, { planId, priceId, payload }) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .put(`${ADMIN}/${planId}/prices/${priceId}`, payload)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },

  deletePlanPrice({}, { planId, priceId }) {
    return new Promise((resolve, reject) => {
      apiClientV1
        .delete(`${ADMIN}/${planId}/prices/${priceId}`)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },
};

export default actions;
